<template>
  <div class="user">
    <div class="profile-card">
      <UserAvatar :size="120" shape="circle" :user="thisUser" />
      <div class="name">{{ thisUser ? thisUser.nickname : null }}</div>
    </div>
    <el-card class="box-card user-card">
      <div class="content">
        <el-tabs>
          <el-tab-pane label="个人信息">
            <div class="tab-content">
              昵称: {{ thisUser ? thisUser.nickname : null }}
              <Authorized permission="POST/MAIL">
                <UserContent />
              </Authorized>
            </div>
          </el-tab-pane>

          <el-tab-pane label="主题">
            <div class="tab-content">
              <el-table
                v-loading="loading"
                :data="list"
                element-loading-text="Loading"
                fit
                highlight-current-row
              >
                <el-table-column label="标题">
                  <template slot-scope="scope">
                    <div class="text-wch text-title">
                      <router-link
                        target="_blank"
                        :to="{
                          name: 'ThreadShow',
                          params: { id: scope.row.id, current: 1 },
                        }"
                      >
                        {{ scope.row.title }}
                      </router-link>
                    </div>
                    <div class="text-sub">
                      {{
                        scope.row.createTime
                          ? $dayjs(scope.row.createTime).format(
                              "YYYY/MM/DD HH:mm:ss"
                            )
                          : null
                      }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination">
                <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="pageSize"
                  :current-page="current"
                  :hide-on-single-page="true"
                  @current-change="onCurrentChange"
                />
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="修改头像"> -->
          <!-- <UserAvatar :size="120" :user="user" /> -->

          <!-- </el-tab-pane> -->
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUser, content } from "@/service/user";
import { getUserTopics } from "@/service/post";
import Authorized from "@/components/Authorized";
import UserAvatar from "@/components/UserAvatar";
import UserContent from "@/components/UserContent";
export default {
  name: "UserEdit",
  data() {
    return {
      userAgentMobile: "",

      thisUser: null,

      dialogVisible: false,

      // 防止重复提交
      loading: false,
      pageSize: 10,
      current: 1,
      total: 0,
      list: [],
    };
  },
  components: {
    UserAvatar,
    UserContent,
    Authorized,
  },
  computed: {
    ...mapGetters(["user"]),
    labelPositionMobile() {
      console.info(this.userAgentMobile);
      return this.userAgentMobile ? "top" : "left";
    },
  },
  created() {
    this.fetchData();
    this.userAgentMobile = window.innerWidth <= 720;
  },

  methods: {
    onCurrentChange(current) {
      this.current = current;
      this.fetchData();
    },
    fetchData() {
      // 获取用户信息
      getUser({
        userId: this.$route.params.id,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          // 返回的data可能为null,为null的可能是没查到,或者被删除了,需要跳转到404
          if(data){
            this.thisUser = data;
            this.$store.dispatch("app/setBreadcrumb", [
              {
                key: 2,
                link: "/",
                value: this.thisUser ? this.thisUser.nickname : null,
              },
            ]);
          }else{
            this.$router.push("/404.html");
          }
        }
      });

      this.loading = true;
      // 获取用户发帖信息
      getUserTopics({
        current: this.current,
        pageSize: this.pageSize,
        userId: this.$route.params.id,
      }).then((res) => {
        this.loading = false;
        const { code, data } = res;
        if (code == 0) {
          this.list = data.records;
          this.total = data.total;
        }
      });
    },
  },
};
</script>
<style lang="less">
.profile-card {
  width: 100%;

  padding: 20px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  background-image: url("https://img.wch.cn/20250225/566620bd-08c1-49b0-a0f9-e131fd7fd1e0.bb785020");
  background-size: cover;
  background-position: center;
  color: white;
}
.name {
  font-size: 24px;
  font-weight: bold;
}
.user-card {
  margin-top: 20px;

  .content {
    text-align: left;

    .tab-content {
      .el-table__header-wrapper {
        display: none;
      }
      margin: 10px;
    }
  }
}
</style>
